// Privacy settings
export var USER_PRIVACY = {
  ANALYTICS_ENABLED: 'userPrivacy_AnalyticsEnabled',
  FUNCTIONAL_ENABLED: 'userPrivacy_FunctionalEnabled',
  TARGETING_ENABLED: 'userPrivacy_TargetingEnabled'
};